import { render, staticRenderFns } from "./Placeholder.vue?vue&type=template&id=0cbad368"
import script from "./Placeholder.vue?vue&type=script&lang=js"
export * from "./Placeholder.vue?vue&type=script&lang=js"
import style0 from "./Placeholder.vue?vue&type=style&index=0&id=0cbad368&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports